class Gateway {
  normalize = (data) => {
    let props = data.assetInfo.metadata.props;
    const nodeName = data.nodeName;
    return {
      id: data.nodeAddress,
      areaId: props.areaId,
      areaName: props.areaName || 'N/A',
      siteId: props.siteId,
      siteName: props.siteName || 'N/A',

      value: props.name || nodeName || data.nodeAddress || 'N/A',
      name: data.nodeName || props.name || data.nodeAddress || 'N/A',
      macAddress: props.macAddress,
      point: props.mapPoint ? props.mapPoint.split(',').map(Number) : [],
      checked: false,
      zoneId: props.zoneId,
      zoneName: props.zoneName,
      lastProvisioned: props.lastProvisioned,
      unprovisionedTime: props.unprovisionedTime,
      installationPictureId: props.installationPictureId,
      locationPictureId: props.locationPictureId,
      otherPictureId: props.otherPictureId,
    };
  };
}

export default Gateway;
